import React, { useState } from "react";
import {FaInfo} from "react-icons/fa";
import { IoMdSkipForward } from "react-icons/io";

const CurrentlyPlaying = ({socket, onSkip, cookies}) => {
    const [currentlyPlaying, setCurrentlyPlaying] = useState({videoID: '', queueUUID: '', title: ''});

    if (socket != null){
        socket.on('currentQueue', (res) => {
            setCurrentlyPlaying(res.currentVideo)
        });
    }

    const onQueue = () => {
        socket.emit('queueVideo', {videoID: currentlyPlaying.videoID, title: currentlyPlaying.title, queuedBy: cookies['rave_username']});
    }


    return (
        <>
            <h3 id='CurrentHeader'>Currently Playing:</h3>
            {currentlyPlaying.videoID != '' ? <div className='QueuedVideo'>
                <IoMdSkipForward class='RemoveVid' onClick={onSkip} style={{cursor: "pointer"}}/>
                <div className='info'>
                    <FaInfo class='MoveVid' />
                    <p className='tooltip'>{currentlyPlaying.queuedBy}</p>
                </div>
                <table><tr>
                    <td><img src={"https://img.youtube.com/vi/"+currentlyPlaying.videoID+"/mqdefault.jpg"} height="50" onClick={onQueue} style={{cursor: "pointer"}}/></td>
                    <td><p>{currentlyPlaying.title}</p></td>
                </tr></table>
            </div>: <p className='EmptyQueue'>Nothing Playing</p>}
            <hr />
        </>
    )
}
export default CurrentlyPlaying;